import React from "react";
import SiteLayout from "./SiteLayout";
import PageTransition from "./PageTransition";

export default function SiteShell() {
  return (
    <SiteLayout>
      <PageTransition />
    </SiteLayout>
  );
}
